import React from "react";
import { useTranslation } from "react-i18next";
import { LuigisboxHitItem } from "./luigisboxAutocompleteTypes";

interface LuigisboxAutocompleteProductsBlockProperties {
    readonly products: LuigisboxHitItem<"item">[];
    readonly onAnchorClick: (productUrl: string) => void;
}

export default function LuigisboxAutocompleteProductsBlock({ products, onAnchorClick }: LuigisboxAutocompleteProductsBlockProperties): React.JSX.Element | undefined {
    const { t } = useTranslation("header");
    const limitedProducts = products.slice(0, 5);

    const productList: React.JSX.Element[] = limitedProducts.map((product) => (
        <div className="autocomplete-product" key={product.attributes.id}>
            <a
                href={product.url}
                className="autocomplete-product-link"
                onClick={(event): void => {
                    event.preventDefault();
                    onAnchorClick(product.url);
                }}
            >
                <span className="autocomplete-product-image">
                    <img src={product.attributes.image_link_s} alt="" />
                </span>
                <span className="autocomplete-product-title" dangerouslySetInnerHTML={{ __html: product.attributes.title }}></span>
            </a>
        </div>
    ));

    if (productList.length === 0) {
        return undefined;
    }

    return (
        <div>
            <div className="autocomplete-section">
                <span>{t("products")}</span>
            </div>
            <div className="autocomplete-results autocomplete-results-products">
                {productList}
            </div>
        </div>
    );
}
